<template>
  <div class="filterBoxContainer">
    <div class="filterboxBar">
      <div
        v-for="(step, index) in stepList"
        v-bind:key="step.label"
        class="step-box"
        :id="'step-box' + (index + 1)"
        @mouseleave="hideTooltip"
        v-touch:tap="(event) => disableStepHoverMobile(event)"
        v-bind:data-matomo-event="matomoEvent(index)"
      >
        <a href="#" v-if="showList || step.active"
           v-on:click.prevent="setStepActive(index)"
           v-touch:tap.prevent="() => setStepActive(index)"
        >
          <input tabindex="-1" :id="'rv-bar'+(index+1)" type="checkbox" />
          <div
            class="filterbox"
            v-bind:class="{active: step.active, passed: step.completed, stepHoverd: stepHoverIndex == (index+1)}"
          >
            <div
              class="label-wrapper"
              @mouseover="stepHoverIndex = (index+1)"
              @mouseleave="stepHoverIndex = 0"
              v-touch:tap="(event) => disableStepHoverMobile(event)"
            >
              <label
                :for="'rv-bar'+(index+1)"
                class="filterbox"
              >
                <span
                  class="blueBackgroundNumber"
                  v-if="!step.completed && stepHoverIndex != (index + 1)"
                >
                  <em>{{index+1}}</em>
                </span>
                <font-awesome-icon
                  icon="chevron-circle-right"
                  size="lg"
                  class="rv-CheckCircleIcon"
                  v-if="stepHoverIndex == (index + 1)"
                />
                <font-awesome-icon
                  icon="check-circle"
                  size="lg"
                  class="rv-CheckCircleIcon"
                  v-if="step.completed && stepHoverIndex != (index + 1)"
                />
                <span>{{step.label}}</span>
                <span v-if="step.optional">&nbsp;({{ $t('optional') }})</span>
              </label>
            </div>
          </div>
        </a>
        <button
            :ref="'rv-tooltip-target' + (index + 1)"
            :id="'rv-tooltip-target' + (index + 1)"
            class="no-btn rv-info-wrapper"
            v-on:click.stop="showTooltip(index + 1)"
            v-touch:tap.stop
            @mouseover="showTooltip(index + 1)"
            v-show="step.active && step.info">
          <font-awesome-icon icon="info-circle" size="1x" class="rv-infoCircleIcon" id="info"/>
        </button>
        <b-tooltip
            :id="'tooltip' + (index + 1)"
            :target="tooltipContainer(index + 1)"
            :container="tooltipContainer(index + 1)"
            triggers=""
            custom-class="info-box"
            :placement="tooltipPlacement"
            boundary="document"
        ><div v-html="step.info"></div></b-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import { AppModule } from '@/store/modules/app'

export default {
  name: "steps",
  props: {
    stepList: Array,
    showList: Boolean
  },
  methods: {
    setStepActive: function(index) {
        if (window._paq != null) {
          let matomoStep = 0;
          if (this.showList) {
            matomoStep = index + 1;
          }
          window.console.log(`/${this.$route.name}/step-${matomoStep}`);
          window._paq.push(['setCustomUrl', `/${this.$route.name}/step-${matomoStep}`]);
          window._paq.push(['trackPageView']);
        }
        if (this.showList) {
          this.$emit("stepActivated", index);
          this.stepHoverIndex = index + 1;
        } else {
          this.stepHoverIndex = 0;
          this.$emit("goToMenu");
        }
        return true;
    },
    disableStepHoverMobile(event) {
       this.stepHoverIndex = 0;
    },
    stepHoverMobile: function() {
       this.stepHoverIndex = index + 1;
    },

    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight(event) {
      this.windowHeight = document.documentElement.clientHeight;
    },
    setTooltipPlacement(event) {
      if (AppModule.hasDynamicInfoPosition) {
        this.tooltipPlacement = (this.windowWidth <= 1145) ? 'top' : 'topleft'
      }
    },
    showTooltip(index) {
      if (this.windowWidth <= 1145 && AppModule.hasDynamicInfoPosition) {
        this.$root.$emit('bv::show::tooltip', 'step-box' + index)
      } else {
        this.$root.$emit('bv::show::tooltip', 'rv-tooltip-target' + index)
      }
      const tooltip = document.getElementById('tooltip' + index)
      tooltip.addEventListener("touchstart", this.allowScroll)
      document.addEventListener('keyup', this.escClose);
    },
    hideTooltip() {
      const tooltip = document.getElementById('tooltip' + (this.currentStepIndex + 1))
      if (document.body.contains(tooltip)) {
        tooltip.removeEventListener("touchstart", this.allowScroll)
      }
      this.$root.$emit('bv::hide::tooltip')
      document.removeEventListener('keyup', this.escClose);
    },
    escClose(event) {
      if (event.keyCode === 27) {
        this.hideTooltip();
      }
    },
    tooltipContainer(index) {
      if (!AppModule.hasDynamicInfoPosition) {
        return 'rv-tooltip-target' + index
      }
      return (this.windowWidth <= 1145) ? 'step-box' + index : 'rv-tooltip-target' + index
    },
    allowScroll(event) {
      event.stopPropagation();
    },
    handleOrientationChange() {
      if (this.windowWidth <= 1145 && navigator.userAgent.match(/Android/i)) {
        this.$nextTick(() => {
          const content = document.getElementById("content");
          if (content) {
            let top = content.getBoundingClientRect().top;
            if (top < 0) {
              content.scrollIntoView()
            }
          }
        })
      }
    },
    matomoEvent(index) {
      return `${this.$route.name}_${this.stepList[index].componentName};box`;
    }
  },
  data() {
    return {
      stepHoverIndex: 0,
      windowWidth: 0,
      windowHeight: 0,
      tooltipPlacement: 'topleft'
    };
  },

  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowWidth);
      window.addEventListener("resize", this.getWindowHeight);
      window.addEventListener("resize", this.setTooltipPlacement);
      window.addEventListener("resize", this.hideTooltip);
      window.addEventListener("click", this.hideTooltip);
      window.addEventListener("touchstart", this.hideTooltip);
      window.addEventListener("orientationchange", this.handleOrientationChange);

      //Init
      this.getWindowWidth();
      this.getWindowHeight();
      this.setTooltipPlacement();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
    window.removeEventListener("resize", this.getWindowHeight);
    window.removeEventListener("resize", this.setTooltipPlacement);
    window.removeEventListener("resize", this.hideTooltip);
    window.removeEventListener("click", this.hideTooltip);
    window.removeEventListener("touchstart", this.hideTooltip);
    window.removeEventListener("orientationchange", this.handleOrientationChange);
  },
  computed: {
    currentStepIndex: function() {
      return AppModule.currentStepIndex
    },
    showMenu: function() {
      return AppModule.showMenu
    }
  },
  watch: {
    showMenu: function(newShowMenu) {
      if (newShowMenu && this.windowWidth <= 534) {
        this.$nextTick(() => {
          const content = document.getElementById("content");
          if (content) {
            let top = content.getBoundingClientRect().top;
            if (top < 68) {
              content.scrollIntoView()
            }
          }
        })
      }
    }
  }
};
</script>

<style lang="scss">
.info-box {
 
  .tooltip-inner {
    top: 0;
    background-color: white;
    color: black;
    border: 1px solid black;
    font-size: 0.875rem;
    font-weight: 400;
    white-space: normal;
    border-radius: 5px;
    padding: 10px;
    min-width: 515px;
    transform: translateX(17px);
    text-align: left;
  
    @media screen and (max-width: $rv-tileBreakpoint) {
      min-width: 340px;
    }
  }
}

.filterBoxContainer {
  font-size: 16px;
  position: relative;
  .filterboxBar {
    position: relative;
  }

  input[type="checkbox"] {
    position: absolute;
    z-index: -1;
    display: block;
    max-width: 1045px;
    opacity: 0;
  }
  input[type="text"] {
    line-height: 1.2rem;
    width: 100%;
    padding: 10px;
    border: 2px solid #d7d7d7;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  div.filterbox {
    background-color: $rv-white;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border-bottom: 4px solid $rv-pressFilterGrey;
    margin-bottom: 9px;
    
    white-space: nowrap;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    text-decoration: none !important;
    color: $rv-primary;
    width: 100%;
    height: 50px;

    label {
      color: #595959;
      cursor: pointer;
      width: 100%;
      height: 46px;
      padding: 11px 15px 10px 16px;
    }

    @media (max-width: $rv-doubleTeaserBreakpoint) {
      margin: 10px 0;
    }

    .rv-CheckCircleIcon {
      color: $rv-primary;
      text-decoration: none;
      font-size: 24px;
      margin-right: 24px;
      vertical-align: bottom;
    }

    &.passed {
      border-bottom-color: $rv-primary;

      label {
        color: $rv-primary;
      }
    }
    &.active {
      border-bottom-color: $rv-primary;

      .blueBackgroundNumber {
        background-color: #595959;
      }
    }
    &.stepHoverd {
      text-shadow: 0.25px 0px 0.1px, -0.25px 0px 0.1px;
      border-bottom-color: $rv-primary;

      label {
        color: $rv-primary;
      }
    }
    &.deactivate {
      color: $rv-pressFilterGrey;
      &:hover {
        border-bottom-color: $rv-pressFilterGrey;
      }
    }
    .step-box {
      position: relative;
    }
  }
  .rv-info-wrapper {
    width: 46px;
    height: 46px;
    position: absolute;
    right: 0;
    top: 0;
  }

  .rv-infoCircleIcon {
    color: #595959;
  }
}

.blueBackgroundNumber {
  background-color: #595959;
  display: inline-block;
  width: 24px;
  height: 24px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  text-align: center;
  color: $rv-white;
  padding-right: 0 !important;
  margin-right: 24px;
  &.active {
    background-color: $rv-primary;
  }
  em {
    font-style: normal;
  }
} //blueBackgroundNumber
</style>